function generatePlanOptionsRollbar(_ref) {
  var response = _ref.response,
    contactId = _ref.contactId;
  var availableContactId = contactId || 'contactId not yet available';
  var errorData = {
    response: response,
    contactId: availableContactId
  };
  window.Rollbar.error('Unable to reach insurance plans endpoint', errorData);
}
export default generatePlanOptionsRollbar;
//# sourceMappingURL=generatePlanOptionsRollbar.js.map